<template>
  <div class="external-test-wrapper">
    <div class="page-container-bg-solid test">
      <div class="page-wrapper">
        <div class="page-wrapper-row full-height">
          <div class="page-content">
            <div class="vue-test-wrapper desktop-spacer" id="vue-test-wrapper">
              <div class="container">
                <transition mode="out-in" name="screen" appear>
                  <div v-if="screen === 'test'" key="test">
                    <!-- sound player -->
                    <audio src ref="audioPlayer" autoplay>
                      Your browser does not support the
                      <code>audio</code> element.
                    </audio>

                    <!-- question wrapper -->
                    <div class="row mobile-spacer">
                      <div class="col-md-12">
                        <div
                          class="portlet light"
                          :class="theme === 'drivepoint' ? 'question-wrapper-drivepoint' : 'question-wrapper-testdrive'"
                          style="margin-bottom: 15px"
                        >
                          <progress-bar :percentage="currentPercentage" color="info" class="sticky"></progress-bar>

                          <div class="portlet-title">
                            <div class="caption clearfix">
                              <span
                                class="caption-subject bold uppercase"
                              >ΕΡΩΤΗΣΗ {{ answeredCount + 1 }} ΑΠΟ {{ totalCount }}</span>
                            </div>

                            <div class="actions">
                              <timer
                                :minutes="minutes"
                                :type="screen==='test'?'remaining':'elapsed'"
                                ref="timer"
                                @tick="value => seconds = value"
                              ></timer>
                            </div>
                          </div>

                          <question-wrapper
                            :question="currentQuestion"
                            v-if="!loading"
                            @answer="answerQuestion"
                            @skip="skipQuestion"
                            @playSound="sound => playSound(sound)"
                            :withSound="withSound"
                            :questionsLeft="questionsLeft"
                            :timerWidth="100 - (100*(seconds/(minutes*60)))"
                            :theme="theme"
                          ></question-wrapper>
                        </div>
                      </div>
                    </div>

                    <!-- toolbar -->
                    <question-toolbar
                      :question="currentQuestion"
                      v-if="!loading"
                      :withSound="withSound"
                      :withPause="withPause"
                      @toggleSound="toggleSound"
                      @togglePause="togglePause"
                      @toggleTheme="toggleTheme"
                      :showToolbar="showToolbar"
                    ></question-toolbar>

                    <!-- bottom panels -->
                    <div class="row">
                      <div class="col-md-9 col-md-push-3">
                        <!-- statistika -->
                        <div class="portlet light">
                          <div class="portlet-title">
                            <div class="caption">
                              <span class="caption-subject bold uppercase">στατιστικα</span>
                            </div>
                          </div>
                          <div class="portlet-body">
                            <p>
                              Μέσος χρόνος ανά ερώτηση:
                              <strong>{{ averageSeconds }}</strong>
                            </p>
                            <progress-bar-stacked
                              :bars="[{color:'success',percentage:100*correctCount/totalCount},
                                                                    {color:'danger',percentage:100*wrongCount/totalCount}]"
                            ></progress-bar-stacked>

                            <progress-bar :percentage="answeredPercentage" color="info"></progress-bar>
                          </div>
                        </div>
                      </div>

                      <!-- info -->
                      <div class="col-md-3 col-md-pull-9">
                        <div class="portlet light">
                          <div class="portlet-title" @click="testing">
                            <div class="caption">
                              <span class="caption-subject bold uppercase">πληροφοριες</span>
                            </div>
                          </div>
                          <div class="portlet-body" v-if="currentQuestion">
                            <div style="margin-bottom: 10px">
                              <question-label :question="currentQuestion"></question-label>
                            </div>
                            <div>
                              <category-label :question="currentQuestion"></category-label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="screen === 'results'">
                    <results
                      :correctQuestions="correctQuestions"
                      :wrongQuestions="wrongQuestions"
                      @restartTest="restartTest"
                      :totalCount="totalCount"
                      :correctCount="correctCount"
                      :wrongCount="wrongCount"
                      :answeredCount="answeredCount"
                      :category="options.category"
                      :saveResults="sendResults"
                      :type="type"
                    ></results>
                  </div>

                  <div v-if="screen === 'emptyQuestions'">
                    <div class="portlet light">
                      <div class="portlet-title">
                        <div class="caption">
                          <span class="caption-subject bold uppercase">Ειδοποιηση</span>
                        </div>
                      </div>
                      <div class="portlet-body">
                        <div class="note note-danger">
                          <h4 class="block">Δεν υπάρχουν ερωτήσεις</h4>
                          <p>Δεν υπάρχουν άλλες ερωτήσεις που χρειάζεται να δεις από αυτόν τον τύπο τεστ. Μπορείς να επιλέξεις κάποια άλλη κατηγορία/ ενότητα για να συνεχίσεις.</p>
                          <p>Αν έχεις ποσοστό ετοιμότητας 100% σημαίνει ότι έχεις τελειώσει τα τεστ και ο εκπαιδευτής σου έχει ενημερωθεί. Μίλησε μαζί του.</p>
                          <br>
                          <p>
                            <a href="javascript: window.history.back();">Επιστροφή</a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QuestionLabel from "./QuestionLabel.vue";
import CategoryLabel from "./CategoryLabel.vue";
import Timer from "./driving-test-components/Timer.vue";
import QuestionToolbar from "./driving-test-components/QuestionToolbar.vue";
import QuestionWrapper from "./driving-test-components/QuestionWrapper.vue";
import ProgressBar from "./ProgressBar.vue";
import ProgressBarStacked from "./ProgressBarStacked.vue";
import Results from "./driving-test-components/Results.vue";
import {
  methods,
  computed,
  hooks,
  watch
} from "./driving-test-components/_methods";

export default {
  name: "drivingTest",
  data: () => {
    return {
      options: {},
      questions: [],
      answers: [],
      totalCount: 0,
      currentQuestion: null,
      minutes: null,
      screen: "",
      loading: true,
      seconds: 0,
      averageSeconds: "-:--",
      withSound: false,
      withPause: null,
      theme: "",
      type: null,
      sendResults: null,
      showToolbar: true
    };
  },
  computed,
  methods,
  watch,
  components: {
    QuestionLabel,
    CategoryLabel,
    Timer,
    QuestionWrapper,
    ProgressBar,
    ProgressBarStacked,
    QuestionToolbar,
    Results
  },
  ...hooks
};
</script>